import React from "react";

export function ImageBackGround({ imageBg }) {

    const myStyle = {
        
        backgroundImage: `url(${imageBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',  // Ensures at least full viewport height
        height: 'auto',  // Allows for height adjustment when scrolling
        width: '100vw',
        position: 'relative',
        top: '30px',
        left: '0',
        zIndex: '-1',
        
    }

    return (
        <>
        <div
            style={myStyle}
        >
            {/* Add your content here, which will be scrollable */}
            <div style={{ height: '200vh' }}>
                {/* Content inside the page */}
              
            </div>
        </div>
    </>
)
}